module.exports = new __parcel__URL__("create-initiative.71932101.svg").toString();